import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { safeLS } from "@/lib/safeStorage";

/* Tema de la pantalla: «oscuro» (noche) o «claro» (blanco). Preferencia PERSONAL de cada usuario, con cualquier rol:
   se guarda en este navegador y, si hay sesión, también en el backend (/me/tema) para que lo siga en cualquier equipo. */
const CLAVE = "tm_tema";
let actual = safeLS.getItem(CLAVE) === "claro" ? "claro" : "oscuro";
const oyentes = new Set();
export const temaGuardado = () => actual;
export function aplicarTema(t) {
  try { document.documentElement.classList.toggle("tm-oscuro", t === "oscuro"); } catch { /* sin DOM */ }
}
function fijar(t, { guardarRemoto = true } = {}) {
  if (t !== "claro" && t !== "oscuro") return;
  actual = t;
  safeLS.setItem(CLAVE, t);
  aplicarTema(t);
  oyentes.forEach((f) => f(t));
  if (guardarRemoto) api.put("/me/tema", { tema: t }).catch(() => { /* sin backend: queda en este navegador */ });
}
/* Al iniciar sesión: el tema guardado en el perfil manda sobre el del navegador. */
export function temaDesdeUsuario(u) {
  if (u && (u.tema === "claro" || u.tema === "oscuro") && u.tema !== actual) fijar(u.tema, { guardarRemoto: false });
}
aplicarTema(actual);
export function useTema() {
  const [tema, setTema] = useState(actual);
  useEffect(() => { oyentes.add(setTema); return () => oyentes.delete(setTema); }, []);
  const alternar = useCallback(() => fijar(actual === "oscuro" ? "claro" : "oscuro"), []);
  const elegir = useCallback((t) => fijar(t), []);
  return [tema, alternar, elegir];
}
